<app-navbar></app-navbar>
<div class="contenedor">
        <router-outlet></router-outlet>
</div>
<app-footer></app-footer>

